import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import { useRetirementAgeLabels } from "web_myplann/Inspiration/Retirement/Hooks/useRetirementAgeLabels";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

const R = Resources.Inspiration.Retirement;

type Props = {
	context: RetirementContext;
	onChangeAge: (value: number) => void;
};

export const RetirementAgeSection: FC<Props> = ({ context, onChangeAge }) => {
	const { t } = useResource();
	const theme = useTheme();
	const { note, formatValue, minLabel, maxLabel } =
		useRetirementAgeLabels(context);

	return (
		<InspirationSection title={t(R.ageTitle)} gap={theme.spacingTokens.sm}>
			<BoxedSliderField
				label={t(R.ageSliderLabel)}
				value={context.retirementAge}
				onChange={onChangeAge}
				min={context.retirementAgeMin}
				max={context.retirementAgeMax}
				step={1}
				formatValue={formatValue}
				minLabel={minLabel}
				maxLabel={maxLabel}
			/>
			{note && (
				<Typography variant="hint" color={theme.palette.grey[500]} relaxed>
					{note}
				</Typography>
			)}
		</InspirationSection>
	);
};
